import { createOptimizedContext } from '@src/contexts/createOptimizedContext';
import {
  HISTORY_ATTRS_DEFAULT_VALUE,
  MULTI_CHAT_STEPS
} from '@src/utils/constants/COPILOT_CONSTANTS';
import { CopilotContextProps } from '@src/utils/types/CopilotTypes';

export const {
  Provider: CopilotProvider,
  useStoreDispatch: useCopilotDispatch,
  useStoreSelector: useCopilotSelector
} = createOptimizedContext<CopilotContextProps>({
  // 🔹 Unique identifier of the active chat
  chatId: '',

  /** 💬 Raw data object of the current active chat */
  chatData: null,

  /** ⚙️ Indicates whether the chat is being initialized and messages are being fetched */
  initializingCopilot: true,

  /** 🧠 Array of prompt templates displayed on the welcome screen */
  prompts: null,

  /** ⏳ True when prompts are being fetched from the backend */
  isFetchingPrompts: false,

  /** 🚀 True while a message is being sent */
  isSending: false,

  /** 🔁 True while polling the latest assistant message for updates */
  isPolling: false,

  /** 🆔 ID of the assistant message currently being polled */
  pollMessageId: '',

  /** 🔄 ID of the message that needs to be reset or retried */
  resetMessageId: null,

  /** 🪟 Current UI step — welcome screen or active chat view */
  multiChatStep: MULTI_CHAT_STEPS.WELCOME,

  /** 📜 Transformed list of chat messages for rendering */
  messages: [],

  /** ✨ True when a new chat session is being created */
  isCreatingChat: false,

  /** 🧭 Pagination metadata for user's chat history */
  historyAttrs: HISTORY_ATTRS_DEFAULT_VALUE,

  /** ❌ Indicates if creating a new chat session failed */
  createChatFailed: false,

  /** ⚠️ True when fetching chat messages fails */
  msgFetchFailed: false,

  /** 🔁 Number of times the user retried fetching messages (max: 3) */
  retryCount: 0
});
